const menu = [
    {
        icon: 'home',
        label: 'Home',
        to: '/ui',
    },
    {
        icon: 'key',
        label: 'Sessions',
        to: '/ui/session',
    },
    {
        icon: 'user-o',
        label: 'Users',
        to: '/ui/person',
    },
    {
        icon: 'building-o',
        label: 'Organizations',
        to: '/ui/organization',
    },
    {
        icon: 'cog',
        label: 'Settings',
        content: [
            {
                icon: 'user-circle-o',
                label: 'Roles',
                to: '/ui/role',
            },
            {
                icon: 'check-square-o',
                label: 'Access Rights',
                to: '/ui/accessRight',
            },
            {
                icon: 'laptop',
                label: 'Applications',
                to: '/ui/application',
            },
            {
                icon: 'archive',
                label: 'Audit Trail',
                to: '/ui/auditTrail',
            },
        ],
    }
];

export default menu;
